import React, { useCallback, useEffect, useMemo } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import Logo from "../../assets/logo.png";
import { useMutation } from "@tanstack/react-query";
import Init2fa from "./init-2fa";
import Verify2fa from "./verify-2fa";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { ErrorMessage, SuccessMessage } from "../../utils/toastify";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
const SignIn = () => {
  const auth = useAuth();
  const validationSchema = useMemo(
    () =>
      Yup.object({
        user: Yup.string().required("Ingrese un usuario").trim(),
        password: Yup.string()
          .required("Ingrese una contraseña")
          .min(6, "La contraseña debe tener al menos 6 caracteres"),
        code: Yup.string().when("step", {
          is: 2,
          then: (schema) =>
            schema
              .required("El código es requerido")
              .length(6, "El código debe tener 6 dígitos")
              .matches(/^\d+$/, "El código debe contener solo números"),
          otherwise: (schema) => schema.notRequired(),
        }),
        uuid: Yup.string().when("step", {
          is: 2,
          then: (schema) => schema.required("UUID es requerido"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
    [],
  );
  const formik = useFormik({
    initialValues: {
      user: "",
      password: "",
      step: 1,
      code: "",
      uuid: "",
      error_code: "",
      attempts_verify: 0,
      attempts: 0,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      init2fa(values);
    },
  });

  const { isPending, mutate: init2fa } = useMutation({
    mutationKey: ["init2fa"],
    mutationFn: async (values) => {
      const response = await axios.post(`${ApiEndpoint}users/login`, {
        user: values.user,
        password: values.password,
      });

      return response.data;
    },
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Error al iniciar sesión, inténtalo de nuevo");
        return;
      }
      if (data?.token) {
        //login original return [[]]
        auth.login(data.user, data.token);
        SuccessMessage("Se ha iniciado sesión correctamente");
      }
      formik.setFieldValue("step", 2);
      formik.setFieldValue("uuid", data.uuid);
    },
    onError: () => {
      formik.setFieldValue("password", "");
      ErrorMessage("Error al iniciar sesión, inténtalo de nuevo");
    },
  });

  const { isPending: isPendingVerify, mutate: verify2fa } = useMutation({
    mutationKey: ["verify2fa"],
    mutationFn: async (values) => {
      const response = await axios.post(`${ApiEndpoint}users/confirmlogin`, {
        uuid: values.uuid,
        code: values.code,
      });

      return response.data;
    },
    onSuccess: (data) => {
      if (data?.token) {
        const user = [data.user];
        auth.login(user, data.token);
        SuccessMessage("Se ha iniciado sesión correctamente");
      }
    },
    onError: () => {
      formik.setFieldValue("code", "");
      formik.setFieldValue(
        "attempts_verify",
        formik.values.attempts_verify + 1,
      );
      formik.setFieldValue("error_code", "Error al verificar el código");
      ErrorMessage("Error al iniciar sesión, inténtalo de nuevo");
    },
  });

  useEffect(() => {
    if (formik.values.attempts_verify >= 3) {
      formik.resetForm();
      formik.setFieldError("code", "El codigo ha sido bloqueado");
      ErrorMessage("El codigo ha sido bloqueado");
      return;
    }
  }, [formik.values.attempts_verify]);

  const signInStep = useCallback(() => {
    switch (formik.values.step) {
      case 1:
        return <Init2fa formik={formik} isLoading={isPending} />;
      case 2:
        return (
          <Verify2fa
            formik={formik}
            isLoading={isPendingVerify}
            onAction={(values) => verify2fa(values)}
          />
        );
      default:
        return <Init2fa formik={formik} />;
    }
  }, [formik.values.step, isPending, isPendingVerify, verify2fa, formik]);

  return (
    <div className="container-fluid grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
      <div className="Form flex items-center justify-center">
        {/* Logo */}
        <img src={Logo} alt="logotipo" className="Logotipo mx-2" />

        {signInStep()}
      </div>

      {/* Cover */}

      <div className="Cover">
        <div className="LoginCover">
          <p>
            Copyright @ODT {new Date().getFullYear()} - Todos los derechos
            reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
